var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPurplePhoneInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 0.841677L5.83341 0.833344C4.91675 0.833344 4.16675 1.58334 4.16675 2.50001V17.5C4.16675 18.4167 4.91675 19.1667 5.83341 19.1667H14.1667C15.0834 19.1667 15.8334 18.4167 15.8334 17.5V2.50001C15.8334 1.58334 15.0834 0.841677 14.1667 0.841677ZM10.8334 5.83334H9.16675V7.50001H10.8334V5.83334ZM10.8334 9.16668H9.16675V14.1667H10.8334V9.16668ZM5.83341 17.5H14.1667V16.6667H5.83341V17.5ZM14.1667 15H5.83341V5.00001H14.1667V15ZM5.83341 2.50001V3.33334H14.1667V2.50001H5.83341Z",
    fill: "#B6B0FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePhoneInfo);
export default __webpack_public_path__ + "static/media/purple-phone-info.205004ce166494fb9f4438384b5e0ad2.svg";
export { ForwardRef as ReactComponent };